// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmbeddedWorkflowModel () {
        return EmbeddedWorkflowModel;
    },
    get ReviewCycleAutomationStatus () {
        return ReviewCycleAutomationStatus;
    },
    get ReviewCycleExternalFormModel () {
        return ReviewCycleExternalFormModel;
    },
    get ReviewCycleFormModel () {
        return ReviewCycleFormModel;
    },
    get ReviewCycleInternalFormModel () {
        return ReviewCycleInternalFormModel;
    },
    get ReviewCycleJobStatus () {
        return ReviewCycleJobStatus;
    },
    get ReviewCycleModel () {
        return ReviewCycleModel;
    },
    get ReviewCycleStatus () {
        return ReviewCycleStatus;
    },
    get ReviewCycleType () {
        return ReviewCycleType;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _review = require("./review");
const ReviewCycleStatus = _zod.z.enum([
    "Completed",
    "Scheduled",
    "Active",
    "N/A"
]);
const ReviewCycleType = _zod.z.enum([
    "manual",
    "automated"
]);
const ReviewCycleJobStatus = _zod.z.enum([
    "idle",
    "building",
    "updating"
]);
const ReviewCycleInternalFormModel = _zod.z.object({
    id: _zod.z.instanceof(_bson.ObjectId).optional(),
    form_id: _zod.z.instanceof(_bson.ObjectId),
    visible: _zod.z.boolean(),
    redacted: _zod.z.boolean(),
    authors: _zod.z.array(_review.ReviewAuthorParticipant).optional(),
    signers: _zod.z.array(_review.ReviewParticipant).optional(),
    external: _zod.z.literal(false),
    authors_due_date: _zod.z.date().nullable().optional(),
    signers_due_date: _zod.z.date().nullable().optional(),
    author: _review.ReviewAuthorParticipant.nullable().optional(),
    signer: _review.ReviewParticipant.nullable().optional(),
    author_objects: _zod.z.array(_zod.z.object({})).optional(),
    completer: _zod.z.string().optional()
});
const ReviewCycleExternalFormModel = ReviewCycleInternalFormModel.extend({
    authors: _zod.z.array(_review.ExternalReviewAuthor).optional(),
    external: _zod.z.literal(true),
    author: _review.ExternalReviewAuthor.nullable().optional()
});
const ReviewCycleFormModel = _zod.z.discriminatedUnion("external", [
    ReviewCycleInternalFormModel,
    ReviewCycleExternalFormModel
]);
const EmbeddedWorkflowModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    forms: _zod.z.array(ReviewCycleFormModel),
    company: _zod.z.instanceof(_bson.ObjectId),
    last_update: _zod.z.date().optional(),
    insensitive_name: _zod.z.string().optional()
});
const ReviewCycleAutomationStatus = _zod.z.union([
    _zod.z.literal("disabled"),
    _zod.z.literal("scheduled"),
    _zod.z.literal("active"),
    _zod.z.literal("ended")
]).nullable();
const ReviewCycleModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    company: _zod.z.instanceof(_bson.ObjectId),
    creator: _zod.z.instanceof(_bson.ObjectId).nullish(),
    subjects: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    user_selection: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    workflow: EmbeddedWorkflowModel,
    start_date: _zod.z.date(),
    admins_only: _zod.z.boolean().optional(),
    easy_add_configs: _zod.z.array(_zod.z.instanceof(_bson.ObjectId).nullable()).optional(),
    group_id: _zod.z.instanceof(_bson.ObjectId).nullable().optional().describe("Deprecated, use department instead"),
    department: _zod.z.instanceof(_bson.ObjectId).nullable().optional(),
    participants: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    reviews: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    completed_reviews: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    unassigned_reports: _zod.z.number(),
    completed: _zod.z.boolean().optional(),
    complete_date: _zod.z.date().nullable().optional(),
    deleted: _zod.z.boolean().optional(),
    is_closing: _zod.z.boolean().optional(),
    unassigned_count: _zod.z.number().optional(),
    automated: _zod.z.boolean().optional().default(false),
    automation_status: ReviewCycleAutomationStatus.optional(),
    timezone: _zod.z.string().optional()
});
